const state = {
	contentObj: {
		stepTwo: false,
		stepThree: false,
		stepFour: false,
		stepFive: false,
		stepSix: false
	},
	//定时器
	treatModleTime: '',
	//完成答题
	overIndex: 0,
	//视诊
	detail: [],
	//鉴别诊断
	detailsz2: [],
	//临床检查
	detail3: [],
	//临床检查-内置
	detailstepPre3: [],
	//最终诊断
	detail4: [],
	//最终诊断
	detail5: [],
	detail6: [],
	//视诊题目回显
	treatmentEcho: [],
	//视诊
	tdetail: [],
	//鉴别诊断
	tdetailsz2: [],
	//临床检查
	tdetail3: [],
	//临床检查-内置
	tdetailstepPre3: [],
	//最终诊断
	tdetail4: [],
	//最终诊断
	tdetail5: [],
	tdetail6: [],
	//视诊题目回显
	ttreatmentEcho: [],
	//诊疗列表
	treatmentList: null,
	//以选中点
	selectPosition: [{
			id: 1,
			accomplish: false,
		},
		{
			id: 2,
			accomplish: false,
		},
		{
			id: 3,
			accomplish: false,
		},
		{
			id: 4,
			accomplish: false,
		},
		{
			id: 5,
			accomplish: false,
		},
	],
	selectPositionObj: {},
	//pointModal弹框
	submitFlag: true,
	//mouthModal弹框
	mouthModalFlag: null,
}

const mutations = {
	VISUAL_EXAMINATION: (state, {
		key,
		value
	}) => {
		if (key === 'detail' ||
			key === 'detailsz2' ||
			key === 'detail3' ||
			key === 'detailstepPre3' ||
			key === 'detail4' ||
			key === 'detail5' ||
			key === 'detail6' ||
			key === 'treatmentEcho'
		) {
			state[key].push(value)
		} else if (key === 'tdetail' ||
			key === 'tdetailsz2' ||
			key === 'tdetail3' ||
			key === 'tdetailstepPre3' ||
			key === 'tdetail4' ||
			key === 'tdetail5' ||
			key === 'tdetail6' ||
			key === 'ttreatmentEcho') {
			if (key === 'tdetail') {
				state['detail'] = value
			} else if (key === 'tdetailsz2') {
				state['detailsz2'] = value
			} else if (key === 'tdetail3') {
				state['detail3'] = value
			} else if (key === 'tdetailstepPre3') {
				state['detailstepPre3'] = value
			} else if (key === 'tdetail4') {
				state['detail4'] = value
			} else if (key === 'tdetail5') {
				state['detail5'] = value
			} else if (key === 'tdetail6') {
				state['detail6'] = value
			} else if (key === 'ttreatmentEcho') {
				state['treatmentEcho'] = value
			}
		} else if (state.hasOwnProperty(key)) {
			state[key] = value
		} else if (key === 'detail6') {
			state.detail6 = value
		} else if (key === 'clear') {
			state.contentObj = {
					stepTwo: false,
					stepThree: false,
					stepFour: false,
					stepFive: false,
					stepSix: false
				},
				//定时器
				state.treatModleTime = '',
				//完成答题
				state.overIndex = 0,
				//视诊
				state.detail = [],
				//鉴别诊断
				state.detailsz2 = [],
				//临床检查
				state.detail3 = [],
				//临床检查-内置
				state.detailstepPre3 = [],
				//最终诊断
				state.detail4 = [],
				//最终诊断
				state.detail5 = [],
				state.detail6 = [],
				//视诊题目回显
				state.treatmentEcho = [],
				//诊疗列表
				state.treatmentList = null,
				//以选中点
				state.selectPosition = [{
						id: 1,
						accomplish: false,
					},
					{
						id: 2,
						accomplish: false,
					},
					{
						id: 3,
						accomplish: false,
					},
					{
						id: 4,
						accomplish: false,
					},
					{
						id: 5,
						accomplish: false,
					},
				],
				state.selectPositionObj = {},
				//pointModal弹框
				state.submitFlag = true,
				//mouthModal弹框
				state.mouthModalFlag = null
		}
	}
}
const actions = {

}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}